import React from 'react';
import { ScanLine, Users, CreditCard, Ticket } from 'lucide-react';

const PRIMARY = '#2D5BFF';

/**
 * QuickActionsRow — a compact, equal-weight row of the core actions so users
 * always have a tidy way to Scan / open a Circle / add a Card / add a Voucher.
 * Replaces the older stack of large, competing promo cards.
 */
export default function QuickActionsRow({ onScan, onCircle, onCard, onVoucher }) {
  const actions = [
    { key: 'scan', label: 'Scan', icon: ScanLine, onClick: onScan, primary: true },
    { key: 'circle', label: 'Circle', icon: Users, onClick: onCircle },
    { key: 'card', label: 'Card', icon: CreditCard, onClick: onCard },
    { key: 'voucher', label: 'Voucher', icon: Ticket, onClick: onVoucher },
  ];
  return (
    <div className="grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)', gap: 10 }} data-testid="quick-actions">
      {actions.map((a) => (
        <button
          key={a.key}
          onClick={a.onClick}
          data-testid={`quick-action-${a.key}`}
          className="flex flex-col items-center justify-center gap-1.5"
          style={{
            background: a.primary ? PRIMARY : '#FFFFFF',
            border: a.primary ? 'none' : '1px solid #EEF2F7',
            borderRadius: 16,
            padding: '12px 4px',
            boxShadow: a.primary ? '0 6px 16px rgba(45,91,255,0.28)' : '0 2px 8px rgba(15,23,42,0.05)',
          }}
        >
          <span
            className="flex items-center justify-center"
            style={{
              width: 34, height: 34, borderRadius: 11,
              background: a.primary ? 'rgba(255,255,255,0.18)' : '#EEF2FF',
            }}
          >
            <a.icon className="w-4 h-4" style={{ color: a.primary ? '#FFFFFF' : PRIMARY }} />
          </span>
          <span style={{ fontSize: 12, fontWeight: 600, color: a.primary ? '#FFFFFF' : '#374151', fontFamily: 'DM Sans, sans-serif' }}>
            {a.label}
          </span>
        </button>
      ))}
    </div>
  );
}
